import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { EM_DASH } from 'libs.constants';
import { Link, useLocalizeMessage, Text, Badge } from 'libs.nucleus';
import { DataTransferTemplateContext } from '../../../contexts/data_transfer_template/data_transfer_template.context';
export const useDataTemplatesDashboardColumns = () => {
    const translate = useLocalizeMessage();
    const { getStatusBadge } = useContext(DataTransferTemplateContext);
    const transferTemplateColumns = useMemo(() => [
        {
            header: translate('Template name'),
            accessorKey: 'name',
            cell: ({ row }) => (_jsx(Link, { LinkComponent: RouterLink, to: `${row.original.id}`, children: row.original.name })),
        },
        {
            header: translate('Description'),
            accessorKey: 'description',
            cell: ({ row }) => (_jsx(Text, { size: 'sm', className: 'text-text-primary line-clamp-2', children: row.original.description || EM_DASH })),
        },
        {
            header: translate('Status'),
            accessorKey: 'status',
            cell: ({ row }) => getStatusBadge(row.original.status),
        },
        {
            header: translate('Is global'),
            accessorKey: 'isGlobal',
            cell: ({ row }) => row.original.isGlobal ? _jsx(Badge, { label: translate('Yes') }) : _jsx(Badge, { label: translate('No') }),
        },
    ], [translate, getStatusBadge]);
    return { transferTemplateColumns };
};
